// General form helper functions

/**
 * Handle image URL changes for forms with multiple image inputs
 * @param {Array} imageUrls - Current array of image URLs
 * @param {number} index - Index of the URL to change
 * @param {string} value - New value for the URL
 * @returns {Array} - Updated array of image URLs
 */
export const handleImageUrlChange = (imageUrls, index, value) => {
  const newImageUrls = [...imageUrls];
  newImageUrls[index] = value;
  return newImageUrls;
};

/**
 * Add a new image URL field to the form
 * @param {Array} imageUrls - Current array of image URLs
 * @returns {Array} - Updated array with a new empty URL field
 */
export const addImageUrl = (imageUrls) => {
  return [...imageUrls, ''];
};

/**
 * Remove an image URL field from the form
 * @param {Array} imageUrls - Current array of image URLs
 * @param {number} index - Index of the URL to remove
 * @returns {Array} - Updated array with the URL removed
 */
export const removeImageUrl = (imageUrls, index) => {
  if (imageUrls.length <= 1) return imageUrls;
  const newImageUrls = [...imageUrls];
  newImageUrls.splice(index, 1);
  return newImageUrls;
};

export default {
  handleImageUrlChange,
  addImageUrl,
  removeImageUrl
};